export default __webpack_public_path__ + "static/Mutagen-2c73d56080c5c6467d1fc5ad0a9ab888.png";